<template>
  <div>
    <b-row class="mb-0">
      <div class="col">
        <p class="mb-0">
          <strong>OBLIGACIONES</strong>
        </p>
      </div>
      <div class="col-sm-4 text-right">
        <button
          class="btn btn-sm btn-success mb-1"
          type="button"
          @click="addInvoice()"
          :disabled="closed_debt"
          v-if="CREATE"
        >Nuevo</button>
      </div>
    </b-row>

    <hr class="p-0 mt-0" />

    <section class="proj-page-section comments">
      <section class="without" v-if="!lstInvoices.length > 0" style="margin-top:0px">
        <div class="row">
          <figure class="text-center">
            <img src="img/sin_gestion.png" alt width="210px" />
          </figure>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <h1>Oops!</h1>
            <h4>
              No hay obligaciones
              <br />en este deudor.
            </h4>
          </div>
        </div>
      </section>

      <div class="comments" v-if="READ && lstInvoices.length > 0">
        <section
          class="box-typical comment box-typical-custom"
          v-for="item in lstInvoices"
          :key="item.id"
        >
          <div class="row">
            <div class="col-sm-2 mr-0">
              <div class="row">
                <div class="col-md-12 text-center">
                  <strong>
                    <p class="mb-2">CREADA POR</p>
                  </strong>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center">
                  <img
                    v-if="item.user_image === null"
                    src="img/avatars/avatar-2-64.png"
                    class="rounded-circle"
                  />
                  <img v-else :src="item.user_image" class="rounded-circle img-gestion" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center mt-2">
                  <p>{{item.user_name}}</p>
                </div>
              </div>
            </div>
            <div class="col-sm-10">
              <div class="row">
                <div class="col-sm-9"></div>
                <div class="col-sm-3 text-right mb-2 pr-0">
                  <b-button
                    size="sm"
                    variant="info"
                    class="mr-1"
                    title="Editar"
                    @click="editInvoice(item)"
                    :disabled="closed_debt"
                    v-if="UPDATE"
                  >
                    <i class="fa fa-edit"></i>
                  </b-button>

                  <b-button
                    size="sm"
                    variant="danger"
                    title="Eliminar"
                    @click="deleteInvoice(item)"
                    :disabled="closed_debt"
                    v-if="DELETE"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <p class="mb-1">
                    <strong>TIPO</strong>
                  </p>
                  <p>{{item.type_name}}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>NUMERO</strong>
                  </p>
                  <p>{{item.number}}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>EMISIÓN</strong>
                  </p>
                  <p>{{formatDate(item.invoice_date)}}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>VENCIMIENTO</strong>
                  </p>
                  <p>{{formatDate(item.due_date)}}</p>
                </div>
                <div class="col">
                  <p class="mb-1">
                    <strong>DÍAS EN MORA</strong>
                  </p>
                  <p>{{item.days_past_due > 0 ? item.days_past_due : 0}}</p>
                </div>
              </div>
              <hr />

              <div class="row">
                <div class="col">
                  <p class="mb-1">
                    <strong>VALOR (COP)</strong>
                  </p>
                  <p>$ {{formatPrice(item.total)}}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>ABONOS (COP)</strong>
                  </p>
                  <p>$ {{formatPrice(item.payment)}}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>CAPITAL (COP)</strong>
                  </p>
                  <p>$ {{formatPrice(item.total - item.payment)}}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>INTERESES (COP)</strong>
                  </p>
                  <p>$ {{formatPrice(item.interest)}}</p>
                </div>

                <div class="col text-danger">
                  <p class="mb-1">
                    <strong>TOTAL DEUDA (COP)</strong>
                  </p>
                  <p class="bg-danger pl-2">$ {{formatPrice(item.total+item.interest-item.payment)}}</p>
                </div>
              </div>
              <div class="row" v-if="role_id != 6">
                <div class="col">
                  <p class="mb-1">
                    <strong>HONORARIOS (COP)</strong>
                  </p>
                  <p>$ {{formatPrice(item.fee)}}</p>
                </div>
              </div>

              <hr />

              <div class="row" v-if="currency">
                <div class="col">
                  <p class="mb-1">
                    <strong>VALOR ({{currency.name}})</strong>
                  </p>
                  <p>$ {{formatPrice(item.currency_total)}}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>ABONOS ({{currency.name}})</strong>
                  </p>
                  <p>$ {{formatPrice(item.currency_payment)}}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>CAPITAL ({{currency.name}})</strong>
                  </p>
                  <p>$ {{formatPrice(item.currency_total - item.currency_payment)}}</p>
                </div>

              </div>

              <div class="row row-footer" v-if="role_id != 6">
                <div class="w100 text-right mr-2 mt-2">
                  <p>
                    <i class="fa fa-clock-o"></i>
                    Creada el &nbsp;{{item.created_at}}
                    <i
                      class="fa fa-clock-o ml-2"
                    ></i>
                    Actualizada el &nbsp;{{item.updated_at}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <pagination
          class="mb-0"
          :data="laravelData"
          @pagination-change-page="getInvoices"
          :limit="limit"
          :show-disabled="showDisabled"
          :size="size"
          :align="align"
        >
          <span slot="prev-nav">Anterior</span>
          <span slot="next-nav">Siguiente</span>
        </pagination>
      </div>
    </section>

    <!-- MODAL PARA LOS CREAR Y EDITAR -->
    <div class="modal fade" id="dlgInvoice">
      <div class="modal-dialog modal-dialog-centered modal-success">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header m-0 p-2">
            <h6 class="modal-title">{{title}} OBLIGACIÓN</h6>
            <button type="button" class="close" @click="closeInvoice()">&times;</button>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <form @submit.prevent="saveInvoice()" method="post" v-if="invoice.debtor_id">
              <b-row>
                <b-col cols="11" sm="11" class="center-block">
                  <b-row>
                    <b-col sm="12" v-if="errores.length">
                      <b-alert show variant="danger">
                        <b>Por favor corrige los siguientes errores:</b>
                        <ul>
                          <li v-for="(error, index) in errores" :key="index">{{ error }}</li>
                        </ul>
                      </b-alert>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbType">Tipo</label>
                        <b-form-select
                          v-model="invoice.type"
                          id="cmbType"
                          :disabled="disabledInvoice"
                        >
                          <template slot="first">
                            <option :value="null" disabled>-- Seleccione --</option>
                          </template>
                          <option value="F">Factura</option>
                          <option value="P">Pagaré</option>
                          <option value="O">Otra</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtNumeroFactura">Nro. Obligación</label>
                        <b-form-input
                          type="text"
                          id="txtNumeroFactura"
                          v-model="invoice.number"
                          :disabled="disabledInvoice"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtFecha">Fecha emisión</label>
                        <b-form-input
                          type="date"
                          id="txtFecha"
                          v-model="invoice.invoice_date"
                          :disabled="disabledInvoice"
                          :max="invoice.due_date"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtFechaVencimiento">Fecha de vencimiento</label>
                        <b-form-input
                          type="date"
                          id="txtFechaVencimiento"
                          v-model="invoice.due_date"
                          :disabled="disabledInvoice"
                          :min="invoice.invoice_date"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <b-form-group>
                        <label for="txtCurrency">Divisa</label>
                        <b-form-input
                          id="txtCurrency"
                          v-model="currency.name"
                          type="text"
                          :disabled="true"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtValueCurrency">Valor</label>
                        <b-form-input
                          type="text"
                          id="txtValueCurrency"
                          v-model="invoice.currency_total"
                          :disabled="disabledInvoice"
                          @change="calculateCurrency()"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtAbonos">Abonos hechos al cliente</label>
                        <b-form-input
                          type="text"
                          id="txtAbonos"
                          v-model="invoice.currency_payment"
                          :disabled="disabledInvoice"
                          @change="calculateCurrency()"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtValor">Valor (COP)</label>
                        <b-form-input
                          type="text"
                          id="txtValor"
                          v-model="invoice.total"
                          :disabled="true"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtAbonos">Abonos hechos al cliente (COP)</label>
                        <b-form-input
                          type="text"
                          id="txtAbonos"
                          v-model="invoice.payment"
                          :disabled="true"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="!disabledInvoice">
                    <b-col sm="6" class="center-block">
                      <b-row>
                        <b-col sm="6">
                          <b-button
                            type="submit"
                            variant="success"
                            class="btn-sm col-sm-12"
                            :disabled="disabledInvoice"
                          >GUARDAR</b-button>
                        </b-col>

                        <b-col sm="6">
                          <b-button
                            type="button"
                            variant="danger"
                            class="btn-sm col-sm-12"
                            @click="closeInvoice()"
                          >CANCELAR</b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LOS CREAR Y EDITAR -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "invoice",
  props: {
    _debtor_id: {
      type: String,
      default: null
    },
    _closed_debt: {
      type: Boolean,
      default: true
    },
    _currency: {
      type: Object,
      default: {}
    }
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      minDate: moment(String(new Date())).format("YYYY-MM-DD"),
      lstInvoices: [],
      pagination: {},
      isEdit: false,
      disabled: false,
      datos: [],
      errores: [],
      isEditAgreement: false,
      disabledInvoice: false,
      debtor_id: null,
      invoice: {
        type: null,
        invoice_date: null,
        due_date: null,
        debtor_id: null,
        number: null,
        total: null,
        interes: null,
        capital: null,
        payment: null,
      },
      closed_debt: false,
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      // VARIABLES PARA LA PAGINACIÓN
      laravelData: {},
      limit: 5,
      showDisabled: true,
      size: "small",
      align: "right",
      currency: null,
      title: "CREAR",
    };
  },
  beforeMount() {
    // debugger;
    this.closed_debt =
      this._closed_debt === undefined ? null : this._closed_debt; // PARA VERIFICAR SI LA DEUDA ESTA CERRADA
    this.debtor_id = this._debtor_id === undefined ? null : this._debtor_id;
    this.currency = this._currency;
    this.enabledActions();
    this.getInvoices();
  },

  methods: {
    getInvoices: function (page = 1) {
      showLoader();
      let id = this.$route.params.id;
      // DETERMINAR EL NUMERO DE LA PAGINA
      // let page = darNumeroPaginaPaginacion(urlPage);

      // ARMAR LA URL CON LA PAGINACIÓN
      let url = `${this.$urlApi}invoices/debtor/${id}?token=${this.token}&page=${page}`;

      this.$http
        .get(url, this.auth, {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log(response);

            this.lstInvoices = response.data.data.data;
            this.laravelData = response.data.data;

            // this.pagination = setPaginator(response.data.data);
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getRowCount(items) {
      return items.length;
    },
    getBadge(status) {
      return getBadge(status);
    },
    getTextStatus(status) {
      return getTextStatus(status);
    },
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
    initParametersInvoice() {
      this.invoice.type = null;
      this.invoice.invoice_date = null;
      this.invoice.due_date = null;
      this.invoice.debtor_id = this.debtor_id;
      // debtor_id= null,
      this.invoice.number = null;
      this.invoice.total = null;
      this.invoice.interes = null;
      this.invoice.capital = null;
      this.invoice.payment = null;
    },
    addInvoice() {
      this.title = "CREAR";
      this.disabledInvoice = false;
      this.initParametersInvoice();
      this.errores = [];
      $("#dlgInvoice").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.isEditAgreement = false;
      $("#dlgInvoice").modal("show");
    },
    editInvoice(item) {

      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE ELIMINAR
      if (!this.isAdmin) {
        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(item._created_at, "YYYY-MM-DD HH:mm:ss");
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (dias > 0 || minutos > 10) {
          this.$swal({
            title: "Oops...",
            text:
              "El registro ya superó los 10 minutos para ser modificado, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.title = "EDITAR";
      this.initParametersInvoice();
      this.errores = [];
      $("#dlgInvoice").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      // this.invoice = item;
      this.invoice = Object.assign({}, item);
      this.file = null;
      this.isEditAgreement = true;
      $("#dlgInvoice").modal("show");
    },
    viewInvoice(item) {
      this.initParametersInvoice();
      $("#dlgInvoice").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      // this.invoice = item;
      this.invoice = Object.assign({}, item);
      this.disabledInvoice = true;
      $("#dlgInvoice").modal("show");
    },
    saveInvoice() {
      if (this.isEditAgreement) {
        this.updateInvoice();
      } else {
        this.$swal({
          title: "Guardar",
          text: "¿Está seguro que toda la información ingresada es correcta?",
          type: "question",
          showCancelButton: true,
          cancelButtonText: "Volver",
          confirmButtonText: "Si",
        }).then((result) => {
          if (result.value) {
            this.createInvoice();
          }
        });
      }
    },
    createInvoice() {
      showLoader();

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.invoice.url = `${location.origin}/#/customers/view/`;
      this.invoice.user_id = auth[0].id;
      this.invoice.auth_is_admin = this.isAdmin;

      this.datos = JSON.stringify(this.invoice);

      this.$http
        .post(`${this.$urlApi}invoices?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          //console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Factura guardada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR
              this.invoice.debtor_id = null;
              this.getInvoices();
              $("#dlgInvoice").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    updateInvoice() {
      // COMO ES UN OBJETO FormData SE DEBE ENVIAR UN POST Y CAMBIAR EL METODO A PUT, SOLO SIRVE PARA LARAVEL
      showLoader();
      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.invoice.url = `${location.origin}/#/customers/view/`;
      // this.invoice.user_id = auth[0].id;
      this.invoice.auth_is_admin = this.isAdmin;

      this.datos = JSON.stringify(this.invoice);

      this.$http
        .put(
          `${this.$urlApi}invoices/${this.invoice.id}?token=${this.token}`,
          this.datos,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          //console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Factura actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR
              this.invoice.debtor_id = null;
              this.getInvoices();
              $("#dlgInvoice").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    deleteInvoice(item) {
      // if (!this.isAdmin && item.status === "A") {
      //   this.$swal({
      //     title: "Advertencia",
      //     text: "La factura no se puede eliminar, ya se encuenta activada!",
      //     type: "warning",
      //     showCancelButton: false,
      //     confirmButtonText: "Aceptar"
      //   });
      //   return false;
      // }

      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE ELIMINAR
      if (!this.isAdmin) {
        var auth = localStorage.getItem("auth");
        auth = JSON.parse(auth);
        var user_id = auth[0].id;

        if (item.user_id != user_id) {
          this.$swal({
            title: "Advertencia",
            text:
              "El resgitro no se puede eliminar, fue creado por otro usuario!",
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }

        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(item._created_at, "YYYY-MM-DD HH:mm:ss");
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (dias > 0 || minutos > 10) {
          this.$swal({
            title: "Oops...",
            text:
              "El registro ya superó los 10 minutos para ser eliminado, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar la factura ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}invoices/${item.id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {
              //console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Factura eliminado correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getInvoices();
                }
              });
            })
            .catch((error) => {
              console.log(error);
              hideLoader();
            });
        }
      });
    },
    closeInvoice() {
      this.isEditAgreement = false;
      this.disabledInvoice = false;
      $("#dlgInvoice").modal("hide");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    enabledActions() {
      // var auth = localStorage.getItem("auth");
      // auth = JSON.parse(auth);
      // this.isCustomer = auth[0].customer_id != null ? true : false;

      // console.log("role_id =>" + this.role_id);

      switch (this.role_id) {
        case "1": // ADIMISTRADOR
          this.CREATE = true;
          this.READ = true;
          this.UPDATE = true;
          this.DELETE = true;
          break;

        case "2": // COMERCIAL
        case "7": // GERENTE COMERCIAL
          this.CREATE = true;
          this.READ = true;
          this.UPDATE = true;
          this.DELETE = true;
          break;

        case "4": // PREJURIDICO
        case "8": // GERENTE PREJURIDICO
        case "5":
        case "9":
          this.CREATE = true;
          this.READ = true;
          this.UPDATE = false;
          this.DELETE = false;
          break;

        case "6": // CLIENTE
          this.CREATE = false;
          this.READ = true;
          this.UPDATE = false;
          this.DELETE = false;
          break;

        default:
          // OTRO ROL
          this.CREATE = false;
          this.READ = false;
          this.UPDATE = false;
          this.DELETE = false;
          break;
      }
    },
    calculateCurrency(){
      this.invoice.currency_id = this.currency.currency_id;
      this.invoice.total = this.invoice.currency_total > 0 ? this.invoice.currency_total * this.currency.value : 0;
      this.invoice.payment = this.invoice.currency_payment > 0 ? this.invoice.currency_payment * this.currency.value : 0;
    }
  },
};
</script>
